// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gi26adadCleiTB {
  position: absolute;
  z-index: 5;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  overflow: hidden;
}
.mtGJhVW7y4qsuZ {
  position: relative;
  width: 100%;
  border-radius: var(--ds-border-radius-200, 8px) var(--ds-border-radius-200, 8px) 0 0;
}
.lmg8PXL_DjvxWH {
  z-index: unset;
  margin: var(--ds-space-0, 0px) var(--ds-space-500, 40px);
  overflow: visible;
}
.v3SDlgPhOyo8Xg {
  position: absolute;
  top: var(--ds-space-250, 20px);
  right: -50px;
  bottom: 50px;
  left: 50px;
  overflow: visible;
}
`, ""]);
// Exports
export var stickersWrapper = `Gi26adadCleiTB`;
export var stickers = `mtGJhVW7y4qsuZ`;
export var cardBackStickersWrapper = `lmg8PXL_DjvxWH`;
export var cardBackStickers = `v3SDlgPhOyo8Xg`;
export default ___CSS_LOADER_EXPORT___;
